
//公共库
import { Message, MessageBox } from "element-ui";
import { Component, Vue } from "vue-property-decorator";

//本地引入
import { countryNoComList } from "@/utils";
import Pagination from "@/comp/Pagination/index.vue";
import { acrossRecommendList, acrossRecommendSave, acrossRecommendDetail, userSearch } from "@/api/request/blogger";
import GFunc from "@/utils/gFunc";

//组件
@Component({
  name: "acrossRecommend",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = []; //列表
  private total: number = 0; //总数
  private countryList: any[] = []; //归属地区列表
  private listLoading: boolean = false; // 列表加载

  //请求数据
  private listQuery: any = {
    //页码
    page: 1,
    page_size: 20,

    //临时数据
    pos: 0,
    belong: "",
  };

  //推荐类型列表
  private posList: any[] = [
    { pos: 0, name: "全部推荐类型" },
    { pos: 1, name: "首页" },
    { pos: 2, name: "广场" },
  ];

  //创建调用
  created() {
    //数据赋值
    this.countryList = countryNoComList;

    //获取列表
    this.getList();
  }

  //获取数据
  private async getList() {
    //显示等待
    this.listLoading = true;

    //获取数据
    const { data } = await acrossRecommendList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //添加
  private handleAdd(): void {
    //数据赋值
    this.addForm = {
      //临时数据
      num_str: "", //推荐数量

      //数据
      id: 0, //ID
      pos: 0, //推荐类型
      num: 0, //推荐数量
      mode: 0, //推荐模式
      status: 1, //状态
      belong: "", //所属地区
      ids: "", //博主ID列表
      countries: "", //地区列表
    };
    this.countries = [];
    this.blogger_list = [];
    this.tagInputMore = "";
    this.tagInput = "";

    //显示界面
    this.dialogVisible = true;
    this.dialogTitle = "添加跨区博主推荐";
  }

  //处理查询
  private handleSearch(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取列表
    this.getList();
  }

  //编辑
  private handleEdit(row: any): void {
    //数据赋值
    this.addForm = {
      //临时数据
      num_str: String(row.num), //推荐数量

      //数据
      id: row.id, //ID
      pos: row.pos, //推荐类型
      num: row.num, //推荐数量
      ids: row.ids, //博主ID列表
      mode: row.mode, //推荐模式
      status: row.status, //状态
      belong: row.belong, //所属地区
      countries: row.countries, //地区列表
    };
    this.countries = String(row.countries).split(",");
    this.blogger_list = [];
    this.tagInputMore = "";
    this.tagInput = "";

    //显示界面
    this.dialogVisible = true;
    this.dialogTitle = "编辑跨区博主推荐";

    //获取博主列表
    if (this.addForm.mode == 2) this.getBloggerList(String(row.ids).split(","));
  }

  //详情
  private handleDetail(row: any): void {
    //获取数据
    this.getDetailData(row.id);

    //显示界面
    this.detailDialogVisible = true;
  }

  //------------------------------- 设置跨区博主推荐 -------------------------------
  //定义变量
  private blogger_list: any = [];
  private countries: string[] = [];
  private dialogTitle: string = "";
  private dialogVisible: boolean = false;
  private dialogLoading: boolean = false;
  private tagInputMore: string = "";
  private tagInput: string = "";

  //表单数据
  private addForm: any = {
    //临时数据
    num_str: "", //推荐数量

    //数据
    id: 0, //ID
    pos: 0, //推荐类型
    num: 0, //推荐数量
    mode: 0, //推荐模式
    status: 1, //状态
    belong: "", //所属地区
    ids: "", //博主ID列表
    countries: "", //地区列表
  };

  //推荐类型选择
  private posSelect: any[] = [
    { pos: 0, name: "请选择推荐类型" },
    { pos: 1, name: "首页" },
    { pos: 2, name: "广场" },
  ];

  //推荐模式选择
  private modeSelect: any[] = [
    { mode: 0, name: "请选择推荐模式" },
    { mode: 1, name: "全部博主" },
    { mode: 2, name: "指定博主" },
  ];

  //状态选择
  private statusSelect: any[] = [
    { status: 0, name: "禁用" },
    { status: 1, name: "启用" },
  ];

  //归属地区
  private countrySelect: any[] = [
    { country: "", name: "请选择归属地区" },
    { country: "MY", name: "MY" },
    { country: "ID", name: "ID" },
    { country: "TW", name: "TW" },
  ];

  //保存
  private async saveConfirm() {
    //基本信息
    if (this.addForm.pos == 0) return this.$message.error("请选择推荐类型！");
    if (this.addForm.mode == 0) return this.$message.error("请选择推荐模式！");
    if (this.addForm.belong == "") return this.$message.error("请选择所属地区！");
    if (Number(this.addForm.num_str) == 0) return this.$message.error("请输入推荐数量！");
    if (this.addForm.mode == 2 && this.blogger_list.length == 0) return this.$message.error("请添加指定博主ID！");

    //数据赋值
    if (this.addForm.mode == 2) {
      var ids: Array<number> = [];
      for (var i: number = 0; i < this.blogger_list.length; i++) {
        ids.push(Number(this.blogger_list[i].id));
      }
      this.addForm.ids = String(ids);
    } else {
      this.addForm.ids = "";
    }
    this.addForm.countries = "";
    this.addForm.num = Number(this.addForm.num_str);
    for (var i: number = 0; i < this.countries.length; i++) {
      if (this.countries[i] != "") {
        this.addForm.countries += this.countries[i] + ",";
      }
    }
    if (this.addForm.countries != "") this.addForm.countries = String(this.addForm.countries).substring(0, this.addForm.countries.length - 1);

    //显示等待
    this.dialogLoading = true;

    //隐藏等待
    setTimeout(() => {
      this.dialogLoading = false;
    }, 2 * 1000);

    //数据请求
    const res = await acrossRecommendSave(this.addForm);

    //修改成功
    if (res.status === 0) {
      //显示提示
      this.$message.success(`设置跨区博主推荐成功`);

      //隐藏对话框
      this.dialogVisible = false;
      this.dialogLoading = false;

      //获取数据
      this.getList();
    }
  }

  //关闭
  private onCloseDialog(): void {
    //隐藏界面
    this.dialogVisible = false;
  }

  //添加目标用户
  private addBlogger(type: any): void {
    //批量添加
    if (type === "more") {
      //获取数据
      this.getBloggerList(this.tagInputMore.trim().split(","));

      //数据清空
      this.tagInputMore = ""; // 清空输入框
    } else {
      //数据处理
      if (/^[1-9]\d*$/.test(this.tagInput.trim()) && this.tagInput.trim() !== "") {
        //获取数据
        this.getBloggerList([this.tagInput.trim()]);

        //数据清空
        this.tagInput = ""; // 清空输入框
      }
      //异常处理
      else {
        this.$message.error("请输入正确形式的ID");
        this.tagInput = "";
      }
    }
  }

  //移除目标用户
  private removeBlogger(id: number): void {
    //数据赋值
    for (var i: number = 0; i < this.blogger_list.length; i++) {
      if (id == this.blogger_list[i].id) {
        this.blogger_list.splice(i, 1);
        break;
      }
    }
  }

  //获取博主列表
  private async getBloggerList(ids: Array<any>) {
    //数据赋值
    var id_list: Array<number> = [];
    for (var i: number = 0; i < ids.length; i++) {
      var is_add: boolean = true;
      for (var j: number = 0; j < this.blogger_list.length; j++) {
        if (Number(ids[i] == this.blogger_list[j].id)) {
          is_add = false;
          break;
        }
      }
      if (is_add) id_list.push(Number(ids[i]));
    }

    //判断获取数据
    if (id_list.length > 0) {
      //显示等待
      this.dialogLoading = true;

      //隐藏等待
      setTimeout(() => {
        this.dialogLoading = false;
      }, 2 * 1000);

      //数据请求
      const { data } = await userSearch({ type: 1, ids: id_list });

      //数据赋值
      for (var i: number = 0; i < data.list.length; i++) {
        this.blogger_list.push(data.list[i]);
      }

      //隐藏界面
      setTimeout(() => {
        this.dialogLoading = false;
      }, 0.5 * 1000);
    }
  }

  //------------------------------- 跨区博主推荐详情 -------------------------------
  //定义变量
  private detailDdata: any = {};
  private detailDialogVisible: boolean = false;
  private detailDialogLoading: boolean = false;

  //获取数据
  private async getDetailData(id: number) {
    //显示等待
    this.detailDialogLoading = true;

    //获取数据
    const { data } = await acrossRecommendDetail({ id: id });

    //数据赋值
    this.detailDdata = data;

    //隐藏等待
    setTimeout(() => {
      this.detailDialogLoading = false;
    }, 0.5 * 1000);
  }

  //关闭界面
  private onCloseDetailDialog(): void {
    //隐藏界面
    this.detailDialogVisible = false;
  }
}
